import React, { useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import client from './apolloClient';
import ProductList from './components/ProductList';
import ProductForm from './components/ProductForm';

export default function App() {
  const [editingProduct, setEditingProduct] = useState(null);

  const handleEdit = (product) => {
    setEditingProduct(product);
  };

  const handleSuccess = () => {
    setEditingProduct(null);
    window.location.reload();
  };

  const handleCancelEdit = () => {
    setEditingProduct(null);
  };

  return (
    <ApolloProvider client={client}>
      <div>
        <h1>Product Management</h1>
        <ProductForm 
          onSuccess={handleSuccess} 
          editProduct={editingProduct}
          onCancelEdit={handleCancelEdit}
        />
        <ProductList onEdit={handleEdit} />
      </div>
    </ApolloProvider>
  );
}
